import {
  MdEmail,
  MdWhatsapp,
  MdLocationOn,
  MdFacebook
} from 'react-icons/md';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaTwitter,
  FaTelegramPlane

} from 'react-icons/fa';
import { FaLocationDot } from "react-icons/fa6";

import { FaXTwitter } from "react-icons/fa6";
import RedirectToMap from '../../../../constants/MapConstants';

export const ContactInfoCard = () => (
  <div className=" rounded-lg font-atkinson flex flex-col items-center text-[#1B1B1B] p-6 xs:p-1 md:p-8 mb-2 md:mb-0">
    <div className="space-y-6">

      {/* Email Section */}
      <div className="flex w-full items-start space-x-3">
        <FaTelegramPlane className="w-5 h-5" />
        <div>
          <h3 className="font-semibold mb-4">Email Us</h3>
          <p className="text-lg p-0 m-0 leading-[1.1]">Our friendly team is <br className='hidden xs:block'/> here to help.</p>
          <a href="mailto:hello@digitmoney.in" className="hover:text-green-700 m-0 p-0 text-lg hover:underline" target="_blank">
            hello@digitmoney.in
          </a>
        </div>
      </div>

      {/* WhatsApp Section */}
      <div className="flex items-start w-full space-x-3">
        <MdWhatsapp className="w-5 h-5 mt-1" />
        <div>
          <h3 className="font-semibold mb-4">WhatsApp</h3>
          <a href="tel:+919833377977" className="hover:text-green-700 text-lg" target="_blank">
            +91 7039000959
          </a>
        </div>
      </div>

      {/* Address Section */}
      <div className="flex items-start justify-center space-x-3">
       <FaLocationDot  className='mt-[-6%] sm:mt-[4px] text-[60px] sm:text-[20px]'/>
        <div>
          <h3 className="font-semibold text-gray-900 mb-4">Address</h3>
          <p onClick={RedirectToMap}
           className="text-gray-600 text-lg leading-relaxed cursor-pointer hover:text-green-700">
            Plot No. 17/18, Level 13, Regus<br className="hidden md:inline" />
            Platinum Business Centre Pvt Ltd,<br className="hidden md:inline" />
            Platinum Techno Park, Sector 30A, Vashi,<br className="hidden md:inline" />
            Navi Mumbai, Thane, Maharashtra - 400705
          </p>

        </div>
      </div>

      {/* Social Media Icons */}
      <div className="flex space-x-4 pt-4">
        <a href="#" className="hover:text-green-600 transition-colors">
          <MdFacebook className="w-5 h-5" />
        </a>
        <a href="#" className="hover:text-green-600 transition-colors">
          <FaInstagram className="w-5 h-5" />
        </a>
        <a href="#" className="hover:text-green-600 transition-colors">
          <FaLinkedinIn className="w-5 h-5" />
        </a>
        <a href="#" className="hover:text-green-600 transition-colors">
          <FaYoutube className="w-5 h-5" />
        </a>
        <a href="#" className="hover:text-green-600 transition-colors">
          <FaXTwitter className="w-5 h-5" />
        </a>

      </div>

    </div>
  </div>
);
